import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import dayjs from "dayjs";
import useCalendar from "../hooks/useCalendar";
import { reasonTranslator } from "../shared/closedReasonTranslator";

export default function PublicCalendar({ numberOfDays = 7 }) {
	const { rosterCalendar, isLoading } = useCalendar(dayjs(), numberOfDays);

	console.log("Comp PublicCalendar: Roster calendar", rosterCalendar);
	console.log("Comp PublicCalendar: IsLoading", isLoading);

	return (
		<Box
			sx={{
				textTransform: "capitalize",
				fontWeight: "medium",
				fontSize: "h6.fontSize",
			}}
		>
			<Table sx={{ borderCollapse: "collapse" }}>
				<TableBody>
									{!isLoading &&
										rosterCalendar
											?.getDays()
											.map((d, i) => {

												const slots = d.getSlots();
												// get slots that has sufficient bookings
												//console.log("Shwoing slots", slots, d);
												const filteredSlots = slots.filter((slot)=> d.showAsOpen(slot) )
												//console.log("Filtered slots", filteredSlots);

											const isOpen = d.isOpen();
												const isSufficient = d.isSufficientlyBooked();
												const missingRoster = isOpen && filteredSlots.length === 0;
												const fullyOpen = isOpen && isSufficient;

												let rowBg = "transparent";
												if (!isOpen) rowBg = "#ffebee"; // red hue - closed
												else if (missingRoster) rowBg = "#f5f5f5"; // grey hue - missing roster
												else if (fullyOpen) rowBg = "#e8f5e9"; // green hue - open

												return (
													<TableRow key={i} sx={{ backgroundColor: rowBg }}>
											<TableCell align="right" sx={{ borderBottom: "1px solid #e0e0e0", py: 1.2 }}>
															<Box
																sx={{
																	textTransform:
																		"capitalize",
																}}
															>
																{d.date.format(
																	"dddd DD.MM"
																)}
															</Box>
														</TableCell>
														<TableCell align="left" sx={{ borderBottom: "1px solid #e0e0e0", py: 1.2 }}>
															{d.isOpen() && 
																d.isSufficientlyBooked() &&
																`${d.getOpeningHoursString()}`}

															{/*filteredSlots.length > 0 && !d.isSufficientlyBooked() && filteredSlots.map((slot, i) => (	

																slot.start + "-" + slot.end))
															*/}

															{d.isOpen() &&
																filteredSlots.length === 0  &&
																"Foreløpig Stengt (Mangler vakt)"}
															{!d.isOpen() &&
																reasonTranslator[
																	d.getClosedReason()
																		? d.getClosedReason()
																		: "closed"
																]}
														</TableCell>
													</TableRow>
												);
											})}
				</TableBody>
			</Table>
		</Box>
	);
}
